import $ from 'jquery';
import NamesWidget from './views/widget';


/* Names Actions Widget */
$('.fm-names-actions').each(function (){
    // This is just attached here for simplicity, as
    // when this way is used, it's on views not built
    // in marionette
    const filter = $('#id_filter');
    new NamesWidget({
        el: this,
        filter
    }).render();
});



// WEBPACK FOOTER //
// ./names/widget.js